import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Td from "./../../../component/atoms/layout/table/td";
import Checkbox from "./../../../component/atoms/input/checkbox";
import Th from "./../../../component/atoms/layout/table/th";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import TableText from "./../../../component/atoms/text/table/tableText";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import ReviewGrade from "./_components/reviewGrade";
import Pagination from "./../../../component/molecules/pagination";
import { route } from "./../../../router/route";
import RedBtn from "./../../../component/atoms/button/redBtn";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import PretendardText from "../../../component/atoms/text/pretendardText";
import Modal from "../../../component/templates/Modal";
import ReviewApi from "../../../api/review.api";
import Empty from "../../../component/molecules/empty";
import moment from "moment";
import { fileUrl } from "../../../api/api";
import styled from "styled-components";
import ReviewDetailPopup from "../../../component/templates/review/relatedProductsPopup";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const ShoppingReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.shopping_review)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");
  const [activationFilter, setActivationFilter] = useState(true);
  const [bestFilter, setBestFilter] = useState(true);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setActivationFilter(
      searchParams.get("activation") === "false" ? false : true
    );
    setBestFilter(searchParams.get("best") === "true" ? true : false);

    getReviewList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [reviewList, setReviewList] = useState([]);

  const getReviewList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      if (searchParams.get("activation") === "false") {
        data.activation = "Inactive";
      }

      if (searchParams.get("best") === "true") {
        data.bestFlag = "Active";
      }

      const response = (await ReviewApi.getList(data)).data.data;

      const processedResponse = response.content.map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
          checked: false,
          imageIsValid: true,
        };
      });

      const processedDataWithImages = await Promise.all(
        processedResponse.map(
          (item) =>
            new Promise((resolve) => {
              if (item.thumbnailServerFileName) {
                const img = new Image();
                img.src = `${fileUrl}/${item.thumbnailServerFileName}`;

                img.onload = () => {
                  resolve({ ...item, imageIsValid: true });
                };

                img.onerror = () => {
                  resolve({ ...item, imageIsValid: false });
                };
              } else {
                resolve(item);
              }
            })
        )
      );

      setReviewList(processedDataWithImages);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 체크 관련 ---------- //

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (reviewList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = reviewList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, reviewList]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      for (let i = 0; i < checkedListStorage.length; i++) {
        await ReviewApi.delete(checkedListStorage[i].id);
      }
      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);
      await getReviewList();

      navigate(
        `${route.shopping_review}?page=1&keyword=${keyword}&activation=${activationFilter}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 활성 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);
  // ---------- 활성 상태 관련 ---------- //
  const [bestFilterOpen, setBestFilterOpen] = useState(false);

  const activationChangeFunc = async (value) => {
    try {
      const data = {
        activation: value,
      };

      for (let i = 0; i < checkedListStorage.length; i++) {
        await ReviewApi.updateActivation(checkedListStorage[i].id, data);
      }

      sessionStorageInit();
      toast(toastMsg.update);
      getReviewList();

      navigate(
        `${route.shopping_review}?page=1&keyword=${keyword}&activation=${activationFilter}&best=${bestFilter}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  const bestFlagChangeFunc = async (value) => {
    try {
      const data = {
        bestFlag: value,
      };

      for (let i = 0; i < checkedListStorage.length; i++) {
        await ReviewApi.update(checkedListStorage[i].id, data);
      }

      sessionStorageInit();
      toast(toastMsg.update);
      getReviewList();

      navigate(
        `${route.shopping_review}?page=1&keyword=${keyword}&activation=${activationFilter}&best=${bestFilter}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 후기 상세보기 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState(false);
  const [detailData, setDetailData] = useState({});

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>후기관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"후기"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"상품, 닉네임, 후기 내용 등"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.shopping_review}?page=1&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.shopping_review}?page=1&keyword=${keyword}`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              {bestFilter ? (
                <GrayBtn
                  onClick={() => {
                    bestFlagChangeFunc(false);
                  }}
                >
                  베스트 후기에서 제외
                </GrayBtn>
              ) : (
                <GrayBtn
                  onClick={() => {
                    bestFlagChangeFunc(true);
                  }}
                >
                  베스트 후기로 지정
                </GrayBtn>
              )}

              {activationFilter ? (
                <GrayBtn
                  onClick={() => {
                    activationChangeFunc(false);
                  }}
                >
                  숨기기
                </GrayBtn>
              ) : (
                <GrayBtn
                  onClick={() => {
                    activationChangeFunc(true);
                  }}
                >
                  숨김 풀기
                </GrayBtn>
              )}

              <RedBtn
                style={{
                  backgroundColor: "#272829",
                }}
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                삭제
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="45px" />
              {/* 날짜 */}
              <col width="116px" />
              {/* 상품 */}
              <col width="231px" />
              {/* 닉네임 */}
              <col width="110px" />
              {/* 후기 내용 */}
              <col width="245px" />
              {/* 상태 */}
              <col width="101px" />
              {/* 베스트 후기 */}
              <col width="60px" />
              {/* 보기 */}
              <col width="80px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...reviewList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          reviewList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    날짜
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상품
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    닉네임
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    후기 내용
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                      justifyContent: "center",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              navigate(
                                `${
                                  route.shopping_review
                                }?page=1&keyword=${keyword}&activation=${true}`
                              );
                            }}
                          >
                            활성
                            {activationFilter ? (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="선택됨"
                              />
                            ) : null}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            navigate(
                              `${
                                route.shopping_review
                              }?page=1&keyword=${keyword}&activation=${false}`
                            );
                          }}
                        >
                          숨김
                          {activationFilter ? null : (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      베스트
                    </TableText>
                    <img
                      className={
                        bestFilterOpen === true ? "rotate" : "rotate-back"
                      }
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setBestFilterOpen(!bestFilterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {bestFilterOpen && (
                      <FilterWrapper
                        style={{
                          minWidth: 100,
                        }}
                      >
                        <FilterTextWrapper>
                          <FilterText
                            style={{
                              gap: 2,
                            }}
                            onClick={() => {
                              navigate(
                                `${
                                  route.shopping_review
                                }?page=1&keyword=${keyword}&activation=${activationFilter}&best=${false}`
                              );
                            }}
                          >
                            전체
                            {bestFilter ? null : (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="선택됨"
                              />
                            )}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            navigate(
                              `${
                                route.shopping_review
                              }?page=1&keyword=${keyword}&activation=${activationFilter}&best=${true}`
                            );
                          }}
                        >
                          베스트
                          {bestFilter ? (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="선택됨"
                            />
                          ) : null}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "center",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {reviewList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "110px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 84,
                          overflow: "visible",
                          whiteSpace: "normal",
                          textOverflow: "clip",
                          wordBreak: "normal",
                        }}
                      >
                        {moment(item.createdAt).format("YYYY-MM-DD HH:mm")}
                      </TableText>
                    </Td>
                    <Td>
                      <div
                        style={{
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {item.merchThumbnailServerFileName &&
                        item.imageIsValid ? (
                          <img
                            src={`${fileUrl}/${item.merchThumbnailServerFileName}`}
                            alt="상품 이미지"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                              marginRight: "16px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              marginRight: "16px",
                              backgroundColor: "#272829",
                            }}
                          />
                        )}
                        <TableText
                          style={{
                            maxWidth: "162px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            wordBreak: "normal",
                            whiteSpace: "normal",
                            WebkitLineClamp: 2, // 2줄부터 ... 표시
                          }}
                        >
                          {item.merchTitle}
                        </TableText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>{item.member.nickname}</TableText>
                    </Td>
                    <Td>
                      <div
                        style={{
                          height: "70px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 5,
                        }}
                      >
                        <ReviewGrade rating={item.score} />
                        <TableText
                          style={{
                            maxWidth: "311px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            wordBreak: "normal",
                            whiteSpace: "normal",
                            WebkitLineClamp: 2, // 2줄부터 ... 표시
                          }}
                        >
                          {item.content}
                        </TableText>
                      </div>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          color: `${item.activation ? "#aaa" : "#cf6679"}`,
                          textAlign: "center",
                        }}
                      >
                        {item.activation ? "활성" : "숨김"}
                      </TableText>
                    </Td>
                    {/* 베스트후기 */}
                    <Td>
                      <TableText
                        style={{
                          textAlign: "center",
                          color: `${item.bestFlag ? "#aaa" : "#cf6679"}`,
                        }}
                      >
                        {item.bestFlag ? "O" : "X"}
                      </TableText>
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          setDetailData(item);
                          setPopupOpen(true);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {reviewList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.shopping_review}
            queryString={`keyword=${keyword}&activation=${activationFilter}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}

      {popupOpen && (
        <ReviewDetailPopup
          detailData={detailData}
          getReviewList={getReviewList}
          setPopupOpen={setPopupOpen}
          isWriteAuthority={isWriteAuthority}
        />
      )}
    </>
  );
};

export default ShoppingReview;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
